export { default } from './InfoBand';
